type ActionIconType = 'email' | 'calendar' | 'external';

function ActionIcon({ type }: { type: ActionIconType }) {
  if (type === 'calendar') {
    return (
      <svg className="contact-action-btn__icon" viewBox="0 0 24 24" aria-hidden>
        <path
          fill="currentColor"
          d="M19 4h-1V2h-2v2H8V2H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 16H5V9h14v11zM7 11h2v2H7v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2z"
        />
      </svg>
    );
  }

  if (type === 'external') {
    return (
      <svg className="contact-action-btn__icon" viewBox="0 0 24 24" aria-hidden>
        <path
          fill="currentColor"
          d="M14 3h7v7h-2V6.41l-9.29 9.3-1.42-1.42 9.3-9.29H14V3zm-2 4H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7h-2v7H5V9h7V7z"
        />
      </svg>
    );
  }

  return (
    <svg className="contact-action-btn__icon" viewBox="0 0 24 24" aria-hidden>
      <path
        fill="currentColor"
        d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z"
      />
    </svg>
  );
}

interface ContactActionButtonProps {
  label: string;
  sublabel: string;
  href: string;
  icon?: ActionIconType;
}

export function ContactActionButton({
  label,
  sublabel,
  href,
  icon = 'email',
}: ContactActionButtonProps) {
  const external = href.startsWith('http');

  return (
    <a
      href={href}
      className="contact-action-btn"
      {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
    >
      <ActionIcon type={icon} />
      <span className="contact-action-btn__text">
        <span className="contact-action-btn__sublabel">{sublabel}</span>
        <span className="contact-action-btn__label">{label}</span>
      </span>
    </a>
  );
}
